import { Navigate, useNavigate } from 'react-router-dom';
import PackageImportPackagesDialog from '../../PackageImportPackagesDialog';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import { usePackagesWizard } from './PackagesWizardContext';

export default function PackageImportSelectContainer() {
  const navigate = useNavigate();
  const { org } = useLegacyAppSession();
  const {
    packageCandidates,
    packageImportSelection,
    resetPackageImportWizard,
  } = usePackagesWizard();

  if (!packageImportSelection) {
    return <Navigate to="/packages/import" replace />;
  }

  return (
    <PackageImportPackagesDialog
      organizationId={Number(org?.id) || undefined}
      facility={packageImportSelection.facility}
      facilityName={packageImportSelection.facilityName}
      market={packageImportSelection.market}
      marketName={packageImportSelection.marketName}
      metrcFacilityId={packageImportSelection.metrcFacilityId}
      packages={packageCandidates}
      onBack={() => navigate('/packages/import', { replace: true })}
      onClose={() => {
        resetPackageImportWizard();
        navigate('/packages', { replace: true });
      }}
      onImported={() => {
        navigate('/packages', { replace: true });
      }}
      onNext={() => {}}
    />
  );
}
